<template>


  <div v-if="store.form.currentStep === 'stepOne'">
    <Steps class="mt-4 mt-md-0" @finishStepEmit="finishStepEmit"/>
    <div class="pl-3 pl-lg-1 pr-3 pr-md-4 pt-4">
      <div class="row">

        <!-- Levy sloupec-->
        <div class="col-12 col-md-6 colBorder">
          <div class="row">
            <!-- Obor zivnosti START-->
            <div class="col-12">
              <hr class="d-md-none"/>
              <div class="form-group">
                <label class="jakeFormCustomLabel" for="oborZivnosti">
                  {{ t('headers.obor') }}
                  <Tooltip title="obor"/>

                  <span v-if="profile.showTradeListAnchor" @click.prevent="scrollToDruhyZivnosti" style="cursor: pointer"
                        class="ml-4 text-primary text-sm">
                      ↓ <span class="text-underline">{{ t('headers.oborKotva') }}</span>
                    </span>
                  <a v-else class="ml-4 text-primary text-sm"
                     href="/vzory-dokumentu-ke-stazeni/EN_seznam_volnych_zivnosti.pdf"
                     download="trade_license_list.pdf"
                     target="_blank">
                    <FontAwesomeIcon :icon="faDownload" size="lg" class="mb-1 ml-1"/>
                    <!--                    ↓ <span class="text-underline">{{ t('headers.oborKotva') }}</span>-->
                  </a>
                </label>
                <textarea class="form-control p-2 p-md-0" id="oborZivnosti"
                          :class="{'is-invalid': isBlurred() && !this.store.order.oborZivnosti }"
                          style="font-size: 14px;"
                          :placeholder="t('placeholders.obor')"
                          v-model="store.order.oborZivnosti" rows="7"></textarea>
                <div class="invalid-feedback">
                  {{ t('errorInput.obor') }}
                </div>
              </div>
            </div>
            <!-- Obor zivnosti END-->


            <!--            V-IF LANG CZ -> typy činnosti-->
            <div class="col-12 mt-2 mt-md-4" v-if="profile.askTradeType">
              <div class="jakeFormCustomLabel mb-2">{{ t('headers.cinnost') }}</div>

              <div class="custom-control custom-radio">
                <input type="radio" id="cinnostMain" class="custom-control-input" value="main"
                       v-model="store.order.cinnost"/>
                <label class="custom-control-label" for="cinnostMain">{{ t('cinnost.main') }}
                  <Tooltip title="typCinnostiHlavni"/>
                </label>

              </div>
              <div class="custom-control custom-radio">

                <input type="radio" class="custom-control-input" id="cinnostSecondary" value="secondary"
                       v-model="store.order.cinnost"/>
                <label class="custom-control-label" for="cinnostSecondary">{{ t('cinnost.secondary') }}
                  <Tooltip title="typCinnostiVedlejsi"/>
                </label>

              </div>
              <hr class="d-md-none">
            </div>


            <!--            V-IF LANG EN-> RESIDENCY -->
            <div class="col-12 mt-2 mt-md-4" v-if="profile.askResidency">
              <div class="dropdown jake-dropdown mb-3">
                <span class="label">
                  {{ t('headers.residency') }}
                  <tooltip title="residency"/>
                </span>

                <a class="dropdown-toggle" href="#"
                   role="button" id="dropdownResidency" data-toggle="dropdown"
                   aria-expanded="false"
                   :class="{'is-invalid' : isBlurred() && !store.order.residency && !isDemand}">
                  <span v-if="store.order.residency">
                    {{ t('input.residency.' + store.order.residency) }}
                  </span>
                  <span v-else>
                    {{ t('input.residency.none') }}
                  </span>
                </a>

                <span v-if="store.order.residency" class="clearButton"
                      v-on:click="store.order.residency = ''"><i
                    class="fa fa-times"></i> </span>

                <div class="dropdown-menu shadow" aria-labelledby="dropdownResidency">
                  <span class="dropdown-item-text text-uppercase text-muted">
                    <small>
                      {{ t('input.residency.none') }}
                    </small>
                  </span>
                  <a class="dropdown-item"
                     :class="{'text-secondary': 'euCitizen' === store.order.residency}"
                     href="#"
                     @click.prevent="store.order.residency = 'euCitizen'">
                    {{ t('input.residency.euCitizen') }}
                  </a>
                  <a class="dropdown-item"
                     :class="{'text-secondary': 'czResidency' === store.order.residency}"
                     href="#"
                     @click.prevent="store.order.residency = 'czResidency'">
                    {{ t('input.residency.czResidency') }}
                    <tooltip title="czechResidency"/>
                  </a>
                  <a class="dropdown-item"
                     :class="{'text-secondary': 'noCzResidency' === store.order.residency}"
                     href="#"
                     @click.prevent="store.order.residency = 'noCzResidency'">
                    {{ t('input.residency.noCzResidency') }}
                  </a>
                </div>
                <div v-if="isBlurred() && !store.order.residency && !isDemand"
                     class="small error-block text-danger mt-1">{{ t('input.residency.error') }}
                </div>
              </div>
            </div>


            <!--       EN -> ECOMONIC ACTIVITY-->
            <div class="col-12 mt-2 mt-md-4" v-if="profile.askEconomicActivity">
              <div class="dropdown jake-dropdown mb-3">
               <span class="label">{{ t('headers.economicActivity') }}
                 <tooltip title="economicActivity"></tooltip>
               </span>

                <a class="dropdown-toggle" href="#"
                   role="button" id="dropdownEconomic" data-toggle="dropdown"
                   aria-expanded="false"
                   :class="{'is-invalid' : isBlurred() && !store.order.economicActivity && !isDemand}">

                  <span v-if="store.order.economicActivity">
                    {{ t('economicActivity.' + store.order.economicActivity) }}
                  </span>
                  <span v-else>
                    {{ t('economicActivity.none') }}
                  </span>
                </a>

                <span v-if="store.order.economicActivity" class="clearButton"
                      v-on:click="selectEconomicActivity('')"><i
                    class="fa fa-times"></i> </span>


                <div class="dropdown-menu shadow" aria-labelledby="dropdownEconomic">
                  <span class="dropdown-item-text text-uppercase text-muted">
                   <small>
                     {{ t('personalForm.chooseEconomicActivity') }}
                   </small>
                  </span>
                  <a class="dropdown-item"
                     :class="{'text-secondary': item === store.order.economicActivity}"
                     href="#" v-for="item in economicActivity"
                     @click.prevent="selectEconomicActivity(item)">
                    {{ t('economicActivity.' + item) }}
                    <tooltip v-if="item==='benefits'" title="socialBenefits"/>
                  </a>

                </div>
                <div v-if="isBlurred() && !store.order.economicActivity && !isDemand"
                     class="small error-block text-danger mt-1">{{ t('economicActivity.none') }}
                </div>

              </div>
            </div>
            <!--            END IF-->

            <div class="col-12 mt-4 mb-4 d-none d-md-block">

              <div class="jakeFormCustomLabel mb-2 pt-3">{{ t('headers.dalsiSluzby') }}</div>
              <div class="custom-control custom-checkbox" @click="showTaxRateInfoMessage">
                <input type="checkbox"
                       class="custom-control-input"
                       id="customCheckRegistrationToFlatRateTax"
                       :disabled="(profile.flatRateNeedsPrimaryActivity && store.order.economicActivity !== 'primary') || store.order.healthInsurance === 'none'"
                       v-model="store.order.regstrationToFlatRateTax">
                <label class="custom-control-label" style="font-size: 14px;" for="customCheckRegistrationToFlatRateTax">
                  {{ t('dalsiSluzby.pausalniDan.firstPart') }}
                  <a :href="t('dalsiSluzby.pausalniDan.url')"
                     class="text-underline"
                     target="_blank">
                    {{ t('dalsiSluzby.pausalniDan.linkPart') }}
                  </a>
                  <tooltip title="flatRateTax"/>
                </label>
                <span v-show="shouldShowTaxRateInfoMessage" class="flat-tax-rate-tooltip shadow">
                  {{ t('errorInput.flatRateTaxPrimaryOnly') }}
                </span>
              </div>
              <div class="custom-control custom-checkbox" v-if="profile.offerTaxReturnService">
                <input type="checkbox" class="custom-control-input" id="customCheckTaxService"
                       v-model="store.order.taxReturnPreparationService">
                <label class="custom-control-label" style="font-size: 14px;" for="customCheckTaxService">
                  {{ t('dalsiSluzby.danovePriznani') }}
                </label>
              </div>
            </div>


          </div>
        </div>
        <!-- Levy sloupec END-->


        <!-- Pravy sloupec-->
        <div class="col-12 col-md-6">

          <div class="mb-4">
            <div class="jakeFormCustomLabel mb-2">{{ t('headers.sidlo') }}</div>
            <div v-if="isBlurred() && !checkSeatType"
                 class="small error-block text-danger mb-2">{{ t('errorInput.sidlo') }}
            </div>
            <!--            VIRTUÁLNÍ SÍDLO RADIO BTN-->
            <div class="custom-control custom-radio mb-2">
              <input type="radio" id="seatJake" class="custom-control-input" value="virtual"
                     :class="{'is-invalid': isBlurred() && !checkSeatType }"
                     v-on:click="setDefaultSeat" v-model="store.order.seatChoose"/>
              <label class="custom-control-label" for="seatJake">{{ t('seat.virtual') }}
                <Tooltip title="virtualniSidloJJ"/>
              </label>

            </div>
            <!--              VIRTUÁLNÍ SÍDLO SELECT-->
            <div v-if="choosedVirtualSeat" class="pl-4">
              <div class="text-muted small pb-2">{{ t('input.seat.virtual.address') }}</div>
              <div class="form-group">
                <!--                VÝBĚR SÍDLA-->
                <select id="selectSeat" class="custom-select" v-model="selectSeat"
                        :class="{'is-invalid': isBlurred() && choosedVirtualSeat && !selectSeat && !isDemand }"
                        v-on:change="clearSelectSeatYear" v-on:click="this.store.order.seatChoose ='virtual'">
                  <option class="p-4" v-for="seat in store.form.seatsProducts" :value="seat">
                    {{ t('sidla.' + seat.code) }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  {{ t('errorInput.seat.virtual.address') }}
                </div>
              </div>
              <div>
                <!--  VÁBĚR OBDOBÍ -->
                <div class="text-muted small pb-2">{{ t('input.seat.virtual.period') }}</div>
                <div class="form-group">
                  <select :disabled="!choosedVirtualSeat || !selectSeat" class="custom-select"
                          v-on:change="updateSeatInOrder"
                          :class="{'is-invalid': isBlurred() && choosedVirtualSeat && !selectSeatYear && !isDemand }"
                          v-model="selectSeatYear">
                    <!-- eurová cena po slevě vychází s desetinami, ve výběru ji zaokrouhlit -->
                    <option v-if="selectSeat" v-for="year in selectSeat.formYears" :value="year">
                      {{ t('years.m' + year.months) }} – {{ profile.pricing === 'standard' ? year.totalPriceWithoutVatFilter : store.formatPriceNoFraction(year.totalPriceWithoutVat) }} {{ t('vat.withoutVat') }}<template v-if="profile.showSalePromo && year.months === '12' && selectSeat.firstYearWebDiscountPercent"> – {{ t('saleBadge') }}</template>
                    </option>
                  </select>
                  <span v-if="profile.showSalePromo && selectSeatYear && selectSeatYear.months === '12' && selectSeat && selectSeat.firstYearWebDiscountPercent"
                        class="badge badge-secondary rounded mt-1 d-inline-block">
                    <s>{{ selectSeatYear.totalPriceWithoutVatNoSaleFilter }}</s>
                    | {{ t('sale') }} {{ selectSeat.firstYearWebDiscountPercent }} % {{ t('na') }} 1. {{ t('year') }}
                  </span>
                  <div v-if="profile.showSalePromo && selectSeatYear && selectSeatYear.months === '12' && selectSeat && selectSeat.firstYearWebDiscountPercent"
                       class="small mt-1 px-2 py-1 rounded"
                       style="background-color: #fdeced;">
                    <span v-html="t('salePromoInfo', { date: salePromoEndDate })"></span>
                  </div>
                  <div class="invalid-feedback">
                    {{ t('errorInput.seat.virtual.period') }}
                  </div>
                </div>
              </div>

            </div>
            <!--            VLASTNÍ SÍDLO RADIO BTN-->
            <div class="custom-control custom-radio">
              <input type="radio" class="custom-control-input" id="seatOwn" value="own"
                     :class="{'is-invalid': isBlurred() && !checkSeatType}"
                     v-on:click="removeSeatFromOrder" v-model="store.order.seatChoose"/>
              <label class="custom-control-label" for="seatOwn">{{ t('seat.own') }}
                <Tooltip title="vlastniAdresa"/>
              </label>
            </div>
            <div v-if="choosedOwnSeat" class="pl-4 ">
              <div class="text-muted small pb-2">{{ t('input.seat.own.address') }}</div>
              <div class="form-label-group mb-1">
                <input id="ownSeatStreet" :disabled="choosedVirtualSeat"
                       class="form-control"
                       :class="{'is-invalid': isBlurred() && choosedOwnSeat && !isFilledOwnSeatStreet}"
                       v-model="store.order.ownSeatAddress.street" placeholder="{{ t('personalForm.ownSeat.street') }}"
                       required=""/>
                <label for="ownSeatStreet" class="ownSeatLabel"> {{ t('personalForm.ownSeat.street') }}</label>
                <div id="validationServer05Feedback" class="invalid-feedback">
                  {{ t('errorInput.seat.own.ulice') }}
                </div>
              </div>
              <div class="form-label-group mb-1">
                <input id="ownSeatCity" :disabled="choosedVirtualSeat"
                       class="form-control"
                       :class="{'is-invalid': isBlurred() && choosedOwnSeat && !isFilledOwnSeatCity }"
                       v-model="store.order.ownSeatAddress.city" placeholder="{{ t('personalForm.ownSeat.city') }}"
                       required=""/>
                <label for="ownSeatCity" class="ownSeatLabel"> {{ t('personalForm.ownSeat.city') }}</label>
                <div id="validationServer05Feedback" class="invalid-feedback">
                  {{ t('errorInput.seat.own.obec') }}
                </div>
              </div>
              <div class="form-label-group mb-1">
                <input type="text" id="ownSeatPostCode" :disabled="choosedVirtualSeat"
                       class="form-control"
                       :class="{'is-invalid': isBlurred() && choosedOwnSeat && !isFilledOwnSeatPsc }"
                       v-model="store.order.ownSeatAddress.psc"
                       v-on:input="preventPscInputFromLetter"
                       v-on:change="store.pscFilter()"
                       placeholder="{{ t('personalForm.ownSeat.psc') }}"
                       required=""/>
                <label for="ownSeatPscownSeatPostCode" class="ownSeatLabel"> {{ t('personalForm.ownSeat.psc') }}</label>
                <div id="validationServer05Feedback" class="invalid-feedback">
                  {{ t('errorInput.seat.own.psc') }}
                </div>
              </div>
              <div id="formGroupOwnCountry">
                <div id="" class="form-label-group">
                  <input id="ownSeatAddressCountry" disabled
                         class="form-control"
                         :value="t('personalForm.ownSeat.country')"
                         :placeholder="t('personalForm.ownSeat.country')" required=""/>
                </div>
                <Tooltip title="adresaVlastnihoSidla"/>

              </div>

            </div>

          </div>


          <div class="d-md-none">
            <hr>
            <div class="jakeFormCustomLabel mb-2">{{ t('headers.dalsiSluzby') }}</div>
            <div class="custom-control custom-checkbox" @click="showTaxRateInfoMessage">
              <input type="checkbox" class="custom-control-input" id="customCheckRegistrationToFlatRateTax"
                     v-model="store.order.regstrationToFlatRateTax"
                      :disabled="profile.flatRateNeedsPrimaryActivity && store.order.economicActivity !== 'primary'">
              <label class="custom-control-label" style="font-size: 14px;" for="customCheckRegistrationToFlatRateTax">
                {{ t('dalsiSluzby.pausalniDan.firstPart') }}
                <a href="https://www.jake-james.cz/blog/pausalni-dan-podminky-terminy-castky"
                   target="_blank"
                   class="text-underline">
                  {{ t('dalsiSluzby.pausalniDan.linkPart') }}
                </a>
              </label>
              <span v-show="shouldShowTaxRateInfoMessage" class="flat-tax-rate-tooltip shadow">
                  {{ t('errorInput.flatRateTaxPrimaryOnly') }}
                </span>
            </div>
            <div class="custom-control custom-checkbox" v-if="profile.offerTaxReturnService">
              <input type="checkbox" class="custom-control-input" id="customCheckTaxService"
                     v-model="store.order.taxReturnPreparationService">
              <label class="custom-control-label" style="font-size: 14px;" for="customCheckTaxService">
                {{ t('dalsiSluzby.danovePriznani') }}
              </label>
            </div>
            <hr>
          </div>


          <div class="mb-4">
            <div class="priceWrapper p-3" style="background-color: #f5f8fc">
              <div class="jakeFormCustomLabel mb-2" data-v-0f2e8fdc="">{{ t('headers.souhrnCeny') }}:</div>
              <TotalPriceOfProducts/>
              <hr>
              <TotalPrice/>

            </div>


          </div>
        </div>


      </div>
    </div>


    <div class="pl-3 pl-md-3 pl-lg-1 pr-3 pr-md-4 ">

      <div class="row">

        <!--        <div class="col-12 mb-4">
                  <div v-for="error in errors" class="alert alert-danger">
                    {{ error }}
                  </div>
                </div>-->
        <div class="col-12 col-md-5 order-last order-md-first text-center text-md-left pb-4 pb-md-0 px-0 px-md-3">
          <div class="px-3">
            <hr class="d-md-none mt-4">
          </div>
          <NeedHelp/>
        </div>
        <div class="col-12 col-md-7 pl-0 pb-0 pb-md-4 text-right d-none d-md-block">

          <button class="btn btn-primary mr-md-3 px-4 " type="button" @click='nextStepDemand'>{{ t('btn.poptat') }}
          </button>
          <button class="btn btn-secondary px-4" type="button" @click='nextStepOrder'>{{ t('btn.objednat') }}</button>

        </div>
        <div class="col-12 col-md-7 pb-md-4 d-md-none">

          <div class="row">
            <div class="col-7 text-left">
              <button class="btn btn-sm btn-primary px-2  " type="button" @click='nextStepDemand'>{{ t('btn.poptat') }}
              </button>

            </div>
            <div class="col-5 text-right">
              <button class="btn btn-sm btn-secondary px-3" type="button" @click='nextStepOrder'>{{
                  t('btn.objednat')
                }}
              </button>

            </div>
          </div>


        </div>

      </div>
    </div>

  </div>
</template>
<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import {useLocaleProfile} from "@/composables/useLocaleProfile";
import TotalPrice from "../others/TotalPrice.vue";
import NeedHelp from "../others/NeedHelp.vue";
import InputText from "../FormsInputs/inputText.vue";
import Tooltip from "../others/Tooltip.vue";
import TotalPriceOfProducts from "../others/TotalPriceOfProducts.vue";
import Steps from "../others/StepsComponent/Steps.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

export default {
  name: "StepOne",
  components: {Steps, FontAwesomeIcon, TotalPriceOfProducts, Tooltip, NeedHelp, TotalPrice, InputText},

  props: ['currentStep'],
  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const {profile} = useLocaleProfile()
    const select = ref(0)
    const lang = locale;
    const now = new Date();
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const salePromoEndDate = `${lastDay.getDate()}. ${lastDay.getMonth() + 1}. ${lastDay.getFullYear()}`;
    return {t, select, lang, faDownload, salePromoEndDate, profile}
  },
  data() {
    return {
      errors: [],
      store,
      selectSeat: null,
      selectSeatYear: null,
      orderSelecetdedSeatYear: null,
      economicActivity:
          [
            'primary',
            'employed',
            'student',
            'benefits',
          ],
      shouldShowTaxRateInfoMessage: false,
    }
  },
  methods: {
    showTaxRateInfoMessage() {
      if(this.profile.flatRateNeedsPrimaryActivity && store.order.economicActivity !== 'primary' && !this.shouldShowTaxRateInfoMessage) {
        this.shouldShowTaxRateInfoMessage = true;
        setTimeout(() => this.shouldShowTaxRateInfoMessage = false, 4000)
      }
    },
    selectEconomicActivity(item) {
      this.store.order.economicActivity = item;
      this.store.order.regstrationToFlatRateTax = false;
      this.shouldShowTaxRateInfoMessage = false;
    },
    downloadItem(url, label) {
      axios.get(url, {responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], {type: 'application/pdf'})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = label
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)
    },
    scrollToDruhyZivnosti() {
      const element = document.getElementById('druhy-zivnosti');
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    },
    finishStepEmit(name) {
      console.log(`finishStepEmit ${name}`);
      this.nextStepOrder();
    },

    // celkova kontrola kroku
    isBlurred() {
      return this.store.form.steps.stepOne.blurred;
    },

    setSeatOwn() {
      console.log('sup');
      this.store.order.seatChoose = 'own'
    },
    checkStep() {
      var order = this.store.order;
      this.store.form.steps.stepOne.filled = false;
      //if (!this.checkTradeType && order.type === 'order') return false;
      if (!order.oborZivnosti) return false;

      if (!this.checkSeatType) return false;
      if (this.choosedOwnSeat) {
        if (!order.ownSeatAddress.city) return false;
        if (!order.ownSeatAddress.street) return false;
        if (!order.ownSeatAddress.psc) return false;
      }

      if (this.choosedVirtualSeat && (!this.selectSeat || !this.selectSeatYear)) return false;
      if (this.profile.askResidency && this.store.order.type === 'order') {
        if (order.economicActivity.length === 0) return false;
        if (order.residency.length === 0) return false;
      }


      return true;

    },
    nextStepOrder() {
      this.store.order.type = 'order';
      this.nextStep();
    },
    nextStepDemand() {
      this.store.order.type = 'demand';
      this.nextStep();
    },
    nextStep() {
      this.store.form.steps.stepOne.blurred = true;

      // od druhého kroku popup.
      this.store.form.formEditing = true;
      // Zkontrolovat, zda URL již obsahuje '?form=editing'
      if (!window.location.href.includes('form=editing') && store.form.formEditing) {
        // Přidat nebo aktualizovat parametr 'form' v URL
        const newUrl = window.location.href.includes('?')
            ? window.location.href + '&form=editing'
            : window.location.href + '?form=editing';

        // Aktualizovat historii bez reloadu stránky
        window.history.pushState({form: 'edit'}, '', newUrl);
      }


      if (this.store.order.seatChoose === 'virtual') {
        this.store.order.ownSeatAddress.city = ''
        this.store.order.ownSeatAddress.street = ''
        this.store.order.ownSeatAddress.psc = ''

      }
      console.log('run check');
      var check = this.checkStep();
      if (check) {
        this.store.form.steps.stepOne.filled = true;
        this.store.form.steps.stepOne.visited = true;
        this.store.form.currentStep = 'stepTwo';

        if (this.store.order.type === 'order') { //začla objednávka
          this.store.tradeClarityEvent('start-order');
          this.store.vueClarityEvent('start-order');
        } else if (this.store.order.type === 'demand') { // začla popávka
          this.store.tradeClarityEvent('start-demand');
          this.store.vueClarityEvent('start-demand');
        }

        this.store.gaEventNextStep('step2');

        this.store.scrollTop();
      } else {
        this.$nextTick(() => {
          this.store.scrollToErrorInput();
        })
        this.store.gaEventErrorForm('step2');
      }

    },
    nextStepTest() {
      console.log('Step one, call fce na pokracovani');
    },


    // check zda se ve store nachazi zivnost a prida k ni poplatek za vyrizeni
    kontrolaZivnosti() {
      var products = this.store.order.products.filter(obj => {
        return this.store.form.druhyZivnostiCodes.indexOf(obj.code) !== -1;
      });
      if (products.length > 0) {
        this.store.addProduct('ZU01');
      } else this.store.removeProduct('ZU01');
    },
    clearSelectSeatYear() {
      if (this.selectSeatYear) this.store.removeProduct(this.selectSeatYear.code);
      this.selectSeatYear = null;
    },

    setDefaultSeat() {
      // nastaví defaultní sídlo po kliknutí na "Virtuální sídlo JJ"
      var seatCode = this.store.form.defaultSeatCode;
      var seat = this.store.getProduct(seatCode);
      this.selectSeat = seat;
      this.selectSeatYear = seat;
      this.updateSeatInOrder();
    },
    updateSeatInOrder() {
      this.store.order.seatChoose = 'virtual';
      if (!this.orderSelecetdedSeatYear) this.orderSelecetdedSeatYear = this.selectSeatYear;

      if (this.orderSelecetdedSeatYear !== this.selectSeatYear) {
        this.store.removeProduct(this.orderSelecetdedSeatYear.code);
        this.orderSelecetdedSeatYear = this.selectSeatYear;

      }
      if (this.selectSeatYear) this.store.addProduct(this.selectSeatYear.code);

    },
    removeSeatFromOrder() {
      if (this.orderSelecetdedSeatYear) {
        this.store.removeProduct(this.orderSelecetdedSeatYear.code)
        this.selectSeatYear = '';
        this.selectSeat = '';
      }
    },

    preventPscInputFromLetter() {
      store.order.ownSeatAddress.psc = store.order.ownSeatAddress.psc.replace(/\D/g, '').substring(0, 5);
    }


  },
  computed: {
    // kontrola jednotlivych poli

    // kontroluje, zda bylo zvoleno vlastni sidlo nebo virtualni
    checkSeatType() {
      if (this.store.order.seatChoose) return true; else return false;
    },
    // others
    getSelectedTradeTypes() {
      return this.store.order.products.filter(obj => {
        return obj.type === 'tradeType'
      });
    },
    choosedVirtualSeat() {
      return this.store.order.seatChoose === 'virtual';
    },
    choosedOwnSeat() {
      return this.store.order.seatChoose === 'own';
    },
    isFilledOwnSeatAddress() {
      var address = this.store.order.ownSeatAddress;
      if (address.city.length < 1) return false;
      else if (address.street.length < 1) return false;
      else if (address.psc.length < 1) return false;
      else if (address.country.length < 1) return false;
      else return true;

    },
    isFilledOwnSeatStreet() {
      return this.store.order.ownSeatAddress.street.length > 0;
    },
    isFilledOwnSeatCity() {
      return this.store.order.ownSeatAddress.city.length > 0;
    },
    isFilledOwnSeatPsc() {
      return String(this.store.order.ownSeatAddress.psc).length > 0;
    },

    isDemand() {
      return this.store.order.type === 'demand';
    },
  },
  mounted() {

  }

}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/helper";

#oborZivnosti {
  &:focus {
    box-shadow: none;
    border-color: #ef4956;
  }
}

#formGroupOwnCountry {
  position: relative;

  .jake-form-tooltip {
    position: absolute;
    left: 115px;
    @media #{$xs} {
      right: 50px;
    }
    bottom: 12px;
  }

  #ownSeatAddressCountry {
    background-color: white;
    color: #dededf;
  }

}

/* Chrome, Safari, Edge, Opera */
#ownSeatPostCode::-webkit-outer-spin-button,
#ownSeatPostCode::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

/* Firefox */
#ownSeatPostCode[type=number] {
  -moz-appearance: textfield !important;
}

.clearButton {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  //border: 1px solid red;
  text-align: center;
  bottom: 1px;
  right: 0px;
  font-size: 12px;
  z-index: +1000;
  cursor: pointer;

}

.flat-tax-rate-tooltip{
  position: absolute;
  left: 0px;
  top: -44px;
  background: white;
  padding: 4px;
  font-size: 14px;
}

</style>